import { ApplicationName, AppState } from "@/lib/types";
import { create } from "zustand";

interface MethodActions {
  setTerminalState: (terminalState: AppState) => void;
  setShowBSOD: (value: boolean) => void;
  setLackShieldState: (lockShieldState: AppState) => void;
  setMusicState: (musicState: AppState) => void;
  setBrowserState: (browserState: AppState) => void;
  setCalculatorState: (calculatorState: AppState) => void;
  setNotesState: (value: AppState) => void;
  setFocusedWindow: (value: ApplicationName) => void;
  setIsSearchBarOpen: (value: boolean) => void;
  setFilesState: (isFilesOpen: AppState) => void;
  setSettingsState: (isSettingsOpen: AppState) => void;
  setPaintState: (isPaintOpen: AppState) => void;
  setChatState: (chatState: AppState) => void;
  setGameState: (gameState: AppState) => void;
  toggleAskMe: () => void;
}

interface MethodState {
  paintState: AppState;
  settingsState: AppState;
  isSearchBarOpen: boolean;
  notesState: AppState;
  filesState: AppState;
  focusedWindow: ApplicationName;
  calculatorState: AppState;
  browserState: AppState;
  musicState: AppState;
  chatState: AppState;
  gameState: AppState;
  askMeState: boolean;
  terminalState: AppState;
  lackShieldState: AppState;
  showBSOD: boolean;
  actions: MethodActions;
}

const useMethodStore = create<MethodState>((set) => ({
  terminalState: "closed",
  paintState: "closed",
  settingsState: "closed",
  filesState: "closed",
  lackShieldState: "closed",
  isSearchBarOpen: false,
  focusedWindow: "Music",
  calculatorState: "closed",
  notesState: "closed",
  browserState: "closed",
  musicState: "closed",
  chatState: "closed",
  gameState: "closed",
  askMeState: false,
  showBSOD: false,
  actions: {
    setFocusedWindow: (value: ApplicationName) => set({ focusedWindow: value }),
    setLackShieldState: (lackShieldState: AppState) => set({ lackShieldState }),
    setGameState: (gameState: AppState) => set({ gameState }),
    setTerminalState: (terminalState: AppState) => set({ terminalState }),
    setNotesState: (notesState: AppState) => set({ notesState }),
    setFilesState: (filesState: AppState) => set({ filesState }),
    toggleAskMe: () => set((state) => ({ askMeState: !state.askMeState })),
    setPaintState: (paintState: AppState) => set({ paintState }),
    setSettingsState: (settingsState: AppState) => set({ settingsState }),
    setIsSearchBarOpen: (value: boolean) => set({ isSearchBarOpen: value }),
    setBrowserState: (browserState: AppState) => set({ browserState }),
    setCalculatorState: (calculatorState: AppState) => set({ calculatorState }),
    setMusicState: (musicState: AppState) => set({ musicState }),
    setShowBSOD: (value: boolean) => set({ showBSOD: value }),
    setChatState: (chatState: AppState) => set({ chatState }),
  },
}));


export const useMethodActions = () => useMethodStore((state) => state.actions);
export default useMethodStore;
